
import styles from "./SurveyPage.module.scss";
import { Layout, PageHeader, UnvButton, UnvModal, UnvInput, Icon, Badge } from "components";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import Notification from "utils/Notifications";
import { PostSurvey } from "service/SurveyService";
import SurveyBody from "./components/SurveyBody";
import { getSurveyData, getSurveyUserData, getSurveyUserAll } from "service/SurveyService";
import rewIcon from "assets/icons/pdf.png";
import filerew from 'assets/files/📝_Руководство_по_использованию_сервиса_анкетирования.pdf'
const SurveyPage = () => {
  const { t } = useTranslation('common');
  const [activeTab, setActiveTab] = useState('available');
  const [openModal, setOpenModal] = useState(false);
  const [body, setBody] = useState("");
  const [render, setRender] = useState(false)
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [data, setData] = useState([]);
  const [userdata, setDataForUser] = useState([]);
  const [usedata, setData2] = useState([]);

  const getData = async () => {
    try { 
      let response = await getSurveyData(data);
      setData(response.data);

    } catch (error) {
    }
  };

  const getDataForUser = async () => {
    try {
      let response = await getSurveyUserData(data);
      setDataForUser(response.data);
    } catch (error) {
    }
  };
  const getDataForUserAll = async () => {
    try {
      let response_user_data = await getSurveyUserAll(data);
      setData2(response_user_data.data)
    } catch (error) {
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!body) {
      setNotify({
        isOpen: true,
        message: t('survey.enter_survey_name_error'),
        type: "error",
      });

    }
    else {
      const formData = new FormData();
      formData.append('title', body);


      let testsinfo = await PostSurvey(formData);

      getData();

      setBody("");
      setOpenModal(false)
      setNotify({
        isOpen: true,
        message: t('survey.survey_created'),
        type: "success",
        sound: "success"
      });
      setRender(true)
    }

  };

  useEffect(() => {
    getData();
    getDataForUser();
    getDataForUserAll();
    setRender(false)

  }, [render]);
  return (
    <Layout>
      <PageHeader
        icon={<Icon name="document" size={28} />}
        title={t('auto.surveypage.title', 'Анкетирование')}
        subtitle={t('auto.surveypage.subtitle', 'Опросы и обратная связь')}
        actions={activeTab === 'create' ? (
          <UnvButton variant="primary" iconLeft="plus" onClick={() => setOpenModal(true)}>{t('survey.create_survey')}</UnvButton>
        ) : null}
      />
      <div className={styles["test-block"]}>
        <div className={styles["tabs"]}>
          <button
            className={`${styles.tab_btn} ${activeTab === 'available' ? styles.active : ''}`}
            onClick={() => setActiveTab('available')}
          >
            <Icon name="chart" /> {t('survey.available_surveys')}
            <span className={styles.h3_3h}>{userdata?.length || 0}</span>
          </button>
          <button
            className={`${styles.tab_btn} ${activeTab === 'completed' ? styles.active : ''}`}
            onClick={() => setActiveTab('completed')}
          >
            <Icon name="success" /> {t('survey.completed_surveys')}
            <span className={styles.h3_3h}>{usedata?.length || 0}</span>
          </button>
          <button
            className={`${styles.tab_btn} ${activeTab === 'create' ? styles.active : ''}`}
            onClick={() => setActiveTab('create')}
          >
            <Icon name="tools" /> {t('survey.constructor')}
            <span className={styles.h3_3h}>{data?.length || 0}</span>
          </button>
          <a href={filerew} download className={styles.sign__rew__btn}>
            <span><Icon name="note" /> {t('survey.guide')}</span>
            <img src={rewIcon} alt={t('survey.download_pdf')} />
          </a>
        </div>
        {activeTab === 'create' && (
          <>
          <div className={styles["test-app"]}>
            <h2>{t('survey.constructor_title')}</h2>
          </div>
          <SurveyBody data={data} isadmin={true} />
          </>
        )}

        {activeTab === 'available' && (
          <>
            <div className={styles["test-app"]}>
              <h2><Icon name="chart" /> {t('survey.available_surveys')}</h2>
            </div>
            <SurveyBody data={userdata} isadmin={false} />
          </>
        )}

        {activeTab === 'completed' && (
          <>
            <div className={styles["test-app"]}>
              <h2><Icon name="success" /> {t('survey.completed_title')}</h2>
            </div>
            <SurveyBody data={usedata} isadmin={false} log={0} />
          </>
        )}

        <UnvModal
          open={openModal}
          onClose={() => setOpenModal(false)}
          title={t('survey.create_survey_modal')}
          size="sm"
        >
          <form onSubmit={handleSubmit} id="survey-create-form">
            <UnvInput
              label={t('survey.enter_survey_name')}
              placeholder={t('survey.enter_survey_name')}
              value={body}
              name="body"
              onChange={(e) => setBody(e.target.value)}
              autoFocus
            />
          </form>
          <UnvModal.Footer>
            <UnvButton variant="ghost" onClick={() => setOpenModal(false)}>{t('survey.cancel')}</UnvButton>
            <UnvButton variant="primary" iconLeft="plus" type="submit" form="survey-create-form">{t('survey.create')}</UnvButton>
          </UnvModal.Footer>
        </UnvModal>
        <Notification notify={notify} setNotify={setNotify} />
      </div>
    </Layout>
  );
};

export default SurveyPage;
